import { useEffect } from "react";
import {
  TextField,
  Grid,
  InputAdornment,
  Autocomplete,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  setDialog,
  resetForm,
  Pins,
} from "../../../app/slices/pinsSlice";
import { Controller, useForm } from "react-hook-form";
import { SelectItem } from "../../../components/Selectors/SelectItems";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { SelectSupplier } from "../../../components/Selectors/SelectSupplier";
import { showNotification } from "../../../app/slices/notificationSlice";
import {
  HiOutlineTicket,
  HiOutlineCreditCard,
  HiOutlineBanknotes,
} from "react-icons/hi2";
import FormDialog, { SectionCard } from "../../../components/FormDialog";

const PinsForm = () => {
  const _Pins = useSelector((state) => state.pins.pin);
  const _SearchBody = useSelector((state) => state.pins.searchBody);

  const isAdd = _Pins.form.id ? false : true;
  const { control, reset, watch, handleSubmit, setValue } = useForm({
    defaultValues: _Pins.form,
  });


  const onSubmit = (data) => {
    if (data.pin_number.length < watch().item_id?.digit_length || data.pin_number.length > watch().item_id?.digit_length) {
      dispatch(showNotification({
        message: `الرقم السري يجب ان يكون ${watch().item_id?.digit_length} رقماً`,
        type: "error"
      }));
    } else {
      if (isAdd) {
        dispatch(Pins.create({
          serial_number: data.serial_number,
          pin_number: data.pin_number,
          expiry_date: data.expiry_date,
          buying_price: data.buying_price,
          item_id: data.item_id.id,
          supplier_id: data.supplier_id.id,
          cash_paid: data.cash_paid,
        }));
      } else {
        dispatch(Pins.update(data.id, {
          serial_number: data.serial_number,
          pin_number: data.pin_number,
          expiry_date: data.expiry_date,
          buying_price: data.buying_price,
          item_id: data.item_id.id,
          status: data.status,
          supplier_id: data.supplier_id.id,
          cash_paid: data.cash_paid,
        }, _SearchBody));
      }
    }
  };
  useEffect(() => {
    reset({ ..._Pins.form });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_Pins.form]);

  useEffect(() => {
    return () => {
      dispatch(resetForm());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const dispatch = useDispatch();

  const handlDialog = () => {
    dispatch(setDialog());
  };

  const status = [
    { key: 'new', name: 'جديد' },
    { key: 'sold', name: 'مباع' },
    { key: 'disabled', name: 'معطل' },
  ]

  return (
    <FormDialog
      open={_Pins.dialog}
      onClose={handlDialog}
      maxWidth='sm'
      icon={<HiOutlineTicket />}
      title={isAdd ? "إضافة كارت جديد" : "تعديل الكارت"}
      subtitle={
        isAdd
          ? "أدخل معلومات الكارت لإضافته"
          : "قم بتحديث معلومات الكارت ثم احفظ التغييرات"
      }
      onSubmit={handleSubmit(onSubmit)}
    >
      <SectionCard icon={<HiOutlineCreditCard />} title="معلومات الكارت">
        <Grid item xs={12} sm={6}>
          <Controller
            name="item_id"
            control={control}
            render={({ field }) => (
              <SelectItem
                required
                value={field.value}
                onChange={(e, newValue) => {
                  setValue("item_id", newValue);
                }}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Controller
            name="supplier_id"
            control={control}
            render={({ field }) => (
              <SelectSupplier
                required
                value={field.value}
                onChange={(e, newValue) => {
                  setValue("supplier_id", newValue);
                }}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Controller
            name="serial_number"
            control={control}
            render={({ field }) => (
              <TextField
                required
                size="small"
                label="الرقم التسلسلي"
                fullWidth
                {...field}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Controller
            name="pin_number"
            control={control}
            render={({ field }) => (
              <TextField
                required
                size="small"
                label="الرقم السري"
                fullWidth
                helperText={watch().pin_number?.length < watch().item_id?.digit_length ||
                  watch().pin_number?.length > watch().item_id?.digit_length ?
                  `الرقم السري يجب ان يكون ${watch().item_id?.digit_length} رقم`
                  : null}
                error={watch().pin_number?.length < watch().item_id?.digit_length ||
                  watch().pin_number?.length > watch().item_id?.digit_length}
                {...field}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Controller
            name="expiry_date"
            control={control}
            render={({ field }) => (
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DesktopDatePicker
                  inputFormat="YYYY-MM-DD"
                  label="تاريخ النفاذ"
                  value={field.value}
                  onChange={(e, newValue) => {
                    setValue("expiry_date", dayjs(e).format("YYYY-MM-DD"));
                  }}
                  renderInput={(params) => (
                    <TextField
                      size="small"
                      fullWidth
                      {...params}
                      inputProps={{ ...params.inputProps, placeholder: "يوم/شهر/سنة" }}
                    />
                  )}
                />
              </LocalizationProvider>
            )}
          />
        </Grid>
        {isAdd ? null : (
          <Grid item xs={12} sm={6}>
            <Controller
              name="status"
              control={control}
              render={({ field }) => (
                <Autocomplete
                  options={status}
                  getOptionLabel={(option) => option.name || ""}
                  value={status.filter(x => x.key == field.value)[0]}
                  onChange={(e, newValue) => {
                    setValue("status", newValue ? newValue.key : null);
                  }}
                  isOptionEqualToValue={(option, value) => option == value}
                  renderInput={(params) => (
                    <TextField

                      {...params}
                      label="الحالة"
                      size="small"
                    />
                  )}
                />
              )}
            />
          </Grid>
        )}
      </SectionCard>
      <SectionCard icon={<HiOutlineBanknotes />} title="المبالغ">
        {isAdd && <Grid item xs={12} sm={6}>
          <Controller
            name="cash_paid"
            control={control}
            render={({ field }) => (
              <TextField
                required
                size="small"
                label="المبلغ المدفوع"
                fullWidth
                {...field}
                InputProps={{
                  startAdornment: <InputAdornment position="start">IQD</InputAdornment>,
                }}
              />
            )}
          />
        </Grid>}
        <Grid item xs={12} sm={isAdd ? 6 : 12}>
          <Controller
            name="buying_price"
            control={control}
            render={({ field }) => (
              <TextField
                required
                size="small"
                label="سعر الشراء للكارت"
                fullWidth
                {...field}
                InputProps={{
                  startAdornment: <InputAdornment position="start">IQD</InputAdornment>,
                }}
              />
            )}
          />
        </Grid>
      </SectionCard>
    </FormDialog>
  );
};

export default PinsForm;